import React, { ReactElement } from 'react';

export const BADGE_VARIANT_GREEN = 'green';
export const BADGE_VARIANT_RED = 'red';
export const BADGE_VARIANT_GRAY = 'gray';
export const BADGE_VARIANT_FILL_GRAY = 'fill-gray';
export const BADGE_VARIANT_DARK_GRAY = 'dark-gray';
export const BADGE_VARIANT_BLUE_SOFT = 'dark-blue';
export const BADGE_VARIANT_BLUE = 'blue';
export const BADGE_VARIANT_YELLOW = 'yellow';
export const BADGE_VARIANT_SMOKE_BLUE = 'smokeBlue';
export const BADGE_VARIANT_SHINY_BLUE = 'shinyBlue';
export const BADGE_VARIANT_TICKET = 'ticket';
export const BADGE_VARIANT_BOTTLE_SERVICE = 'bottleservice';
export const BADGE_VARIANT_GUEST_LIST = 'guestlist';
export const BADGE_VARIANT_PASS = 'pass';
export const BADGE_VARIANT_INVITATION = 'invitation';
export const BADGE_VARIANT_SOLD = 'gradientBlue';
export const BADGE_VARIANT_SCHEDULED = 'rose';
export const BADGE_VARIANT_IN_REVIEW = 'inReview';
export const BADGE_VARIANT_PINK_SOFT = 'pinkSoft';
export const BADGE_VARIANT_PURPLE_SOFT = 'purpleSoft';
export const BADGE_VARIANT_ORANGE_SOFT = 'orangeSoft';
export const BADGE_VARIANT_LIGTH_BLUE_SOFT = 'lightBlueSoft';

export type Variant =
  | typeof BADGE_VARIANT_BLUE
  | typeof BADGE_VARIANT_BOTTLE_SERVICE
  | typeof BADGE_VARIANT_BLUE_SOFT
  | typeof BADGE_VARIANT_DARK_GRAY
  | typeof BADGE_VARIANT_GRAY
  | typeof BADGE_VARIANT_FILL_GRAY
  | typeof BADGE_VARIANT_GREEN
  | typeof BADGE_VARIANT_GUEST_LIST
  | typeof BADGE_VARIANT_RED
  | typeof BADGE_VARIANT_SMOKE_BLUE
  | typeof BADGE_VARIANT_SOLD
  | typeof BADGE_VARIANT_SHINY_BLUE
  | typeof BADGE_VARIANT_TICKET
  | typeof BADGE_VARIANT_INVITATION
  | typeof BADGE_VARIANT_PASS
  | typeof BADGE_VARIANT_YELLOW
  | typeof BADGE_VARIANT_SCHEDULED
  | typeof BADGE_VARIANT_PINK_SOFT
  | typeof BADGE_VARIANT_ORANGE_SOFT
  | typeof BADGE_VARIANT_LIGTH_BLUE_SOFT
  | typeof BADGE_VARIANT_PURPLE_SOFT
  | typeof BADGE_VARIANT_IN_REVIEW;

export interface Props {
  children: ReactElement | string;
  variant: Variant;
  className?: string;
  squared?: boolean;
  block?: boolean;
  isDiscard?: boolean;
  dataTestId?: string;
  onClick?: (e: React.MouseEvent) => void;
}
